<template>
  <div>
    <h1>Game Document</h1>
    <div v-if="!activeId" class="mt-2 grey--text">No game id provided.</div>
    <div v-else>
      <div class="mt-2 grey--text">Document: games/{{ activeId }}</div>
      <div v-if="loading" class="mt-4">Loading…</div>
      <div v-else-if="!docExists" class="mt-4 red--text">Document not found.</div>
      <div v-else class="mt-4">
        <pre class="white--text" style="white-space: pre-wrap; word-break: break-word;">{{ prettyJson }}</pre>
      </div>
    </div>
  </div>
</template>

<script>
import { doc, onSnapshot } from 'firebase/firestore'
import { db } from '@/firebase/init'
export default {
  name: 'GameDocument',
  props: {
    id: { type: String, default: null }
  },
  data() {
    return {
      loading: false,
      docExists: false,
      data: null,
      unsub: null,
    }
  },
  computed: {
    activeId() {
      return this.id || (this.$route && this.$route.params && this.$route.params.id) || null
    },
    prettyJson() {
      try { return JSON.stringify(this.data || {}, null, 2) } catch { return String(this.data) }
    }
  },
  watch: {
    activeId: {
      immediate: true,
      handler() { this.subscribe() }
    }
  },
  methods: {
    subscribe() {
      if (this.unsub) { this.unsub(); this.unsub = null }
      this.data = null
      this.docExists = false
      if (!this.activeId) return
      this.loading = true
      const ref = doc(db, 'games', this.activeId)
      this.unsub = onSnapshot(ref, (snap) => {
        this.loading = false
        this.docExists = snap.exists()
        this.data = this.docExists ? snap.data() : null
      }, (err) => {
        this.loading = false
        console.error('GameDocument snapshot error', err)
        this.$snackbar && this.$snackbar.error('Failed to load game document')
      })
    }
  },
  beforeDestroy() {
    if (this.unsub) { try { this.unsub() } catch {} this.unsub = null }
  }
}
</script>
